import React from 'react';
// Import React dependencies.
import Editor, { BtnBold, BtnBulletList, BtnItalic, BtnLink, BtnNumberedList, BtnStrikeThrough, BtnStyles, ContentEditableEvent, Separator, Toolbar } from 'react-simple-wysiwyg';

const Tiptap = (props: {
    html: string;
    onChange: (e: ContentEditableEvent) => void;
    className?: string;
}) => {

    const [html, setHtml] = React.useState(props.html);
    const [isHtmlMode, setIsHtmlMode] = React.useState(false);

    function onChange(e: ContentEditableEvent) {
        setHtml(e.target.value);
        props.onChange(e);
    }

    const toggleMode = () => setIsHtmlMode(!isHtmlMode);

    return (
        <div className="editor-container">
            <button onClick={toggleMode}>
                {isHtmlMode ? 'WYSIWYG' : 'HTML'}
            </button>
            {isHtmlMode ? (
                <textarea
                    value={html}
                    onChange={onChange}
                    style={{ width: '100%', height: '200px', fontFamily: 'monospace' }}
                />
            ) : (
                <Editor className={props.className} value={html} onChange={onChange}>
                    <Toolbar>
                        <BtnBold />
                        <BtnItalic />
                        <BtnStrikeThrough />
                        <Separator />
                        <BtnNumberedList />
                        <BtnBulletList />
                        <BtnStyles>
                            <option value="p">Paragraphe</option>
                            <option value="h2"><h2>En-tête 2</h2></option>
                            <option value="h3"><h3>En-tête 3</h3></option>
                            <option value="pre"><pre>Code</pre></option>
                        </BtnStyles>
                        <BtnLink />

                    </Toolbar>
                </Editor>
            )}
        </div>
    );
};

export default Tiptap;
